import AlertsAll from 'common/alerts/containers/alert-all-container';
import DashboardContainer from 'common/dashboard/containers/dashboard-container';
import CreateOrders from 'order/create/containers/create-orders-container';
import PropTypes from 'prop-types';
import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { Route, Routes } from 'react-router-dom';
import { referenceTypes } from '../../utils/app-configs';

const FunctionalLocationDashboard = ({ id, renderMenu }) =>
  <>
    <DashboardContainer
      type={referenceTypes.functionallocation}
      id={id}
      hasContract={true}
      hasEquipments={true}
      renderMenu={renderMenu}
      canCreateOrder={true}
      hasAlert={false}
      hasShortTimeline={isToggleEnabled('functionalLocationTimeLine')}
      canCreateTicket={isToggleEnabled('functionalLocationTicketFilter')}
    />
    <Routes>
      <Route path={'alerts'} element={<AlertsAll />} />
      <Route path={'create-order/:type/:ids'} element={<CreateOrders />} />
    </Routes>
  </>;
FunctionalLocationDashboard.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default FunctionalLocationDashboard;
